/**
 * Public directory search helpers (platform suggestions).
 */
export class SearchApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Platform-wide recent or trending directory search terms.
     * Public — no authentication required. Response never includes counts/timestamps.
     */
    async getSuggestions() {
        return this.client.get('/api/search/suggestions');
    }
}
//# sourceMappingURL=search-api.js.map